<template>
    <div class="uploadPicture-protocol" v-if="isShow">
        <div class="uploadPicture-protocolCon">
            <div class="article scroll-container">
                <h1>"皇家加勒比国际游轮"秀美图使用规则</h1>
                <p>欢迎使用"皇家加勒比国际游轮"秀美图（“秀美图”）服务，在您使用前，请仔细阅读本使用规则。本使用规则是隐私政策(<a href="https://mobile.rcclchina.com.cn/Rccl.UserCenter/Privacy" target="_blank" class="external" style="word-wrap:break-word;">https://mobile.rcclchina.com.cn/Rccl.UserCenter/Privacy</a>)及法律声明(<a href="https://mobile.rcclchina.com.cn/wz_index_law/index" target="_blank" class="external" style="word-wrap:break-word;">https://mobile.rcclchina.com.cn/wz_index_law/index</a>)的一部分，构成用户与本公司之间关于使用本公司网站及相关服务的书面协议（“使用条款”）；如果您对使用条款有任何异议，您可以选择不使用秀美图服务；如您使用秀美图服务，包括但不限于登录、浏览、发布、编辑、点赞等，即表示您同意并将自愿遵守使用条款，并受使用条款之约束。</p>
                <p>本公司保留自行决定随时变更、修改、删除或以其他方式改变使用条款的任何部分的权利，任何此类变更、修改、删除或改变应于其公布于本公司网站起立即生效。请用户定期查阅使用条款的变更。您在此类条款变更公布后继续使用秀美图服务即表示您接收此类变更。</p>
                <p><strong>一、服务总则</strong></p>
                <p>
                    1、秀美图服务是皇家加勒比游轮船务（中国）有限公司（“皇家加勒比”或“本公司”），为用户提供美图及信息发布、分享的平台 。<br>
                    2、用户理解并同意，本服务涉及互联网及移动通讯等服务，可能会因不可抗力、计算机病毒、黑客攻击、系统不稳定、用户所在位置、通信线路等本公司无法预测或控制的原因，造成服务中断、取消或终止等风险，对此本公司无需承担任何责任。<br>
                    3、用户理解并同意，本公司有权于任何时间基于任何理由暂时或永久地中断、修改或终止本服务或其任何部分，并无需对此承担任何责任。<br>
                </p>
                <p><strong>二、使用条件</strong></p>
                <p class="">1、用户应遵守中华人民共和国相关法律法规的规定，包括不限于《著作权法》、《计算机信息网络国际联网安全保护管理办法》、《互联网信息服务管理办法》、《互联网电子公告服务管理规定》、《关于维护互联网安全的决定》等有关知识产权和计算机互联网规定的法律、法规和实施办法</p>
                <p>
                    2、用户不得利用本服务从事任何违法或不正当的行为，包括不限于发表、上传或以其它方式传播如下信息：<br>
                    1）反对宪法所确定的基本原则的；<br>
                    2）危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；<br>
                    3）损害国家荣誉和利益的；<br>
                    4）煽动民族仇恨、民族歧视、破坏民族团结的；<br>
                    5）破坏国家宗教政策，宣扬邪教和封建迷信的；<br>
                    6）散布谣言，扰乱社会秩序，破坏社会稳定的；<br>
                    7）散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；<br>
                    8）侮辱或者诽谤他人，侵害他人合法权利的；<br>
                    9）煽动非法集会、结社、游行、示威、聚众扰乱社会秩序的；<br>
                    10）以非法民间组织名义活动的；<br>
                    11）违背伦理道德，违反社会公序良俗的；<br>
                    12）有损皇家加勒比及其关联公司品牌和产品的；<br>
                    13）不符合服务主旨的，如广告或广告的文字、图片或链接等的；<br>
                    14)法律、行政法规禁止的其他内容的，或本公司认为不利于本公司或网站或可能给本公司或网站造成损失的内容的。
                </p>
                <p>
                    3、皇家加勒比有权要求用户改正或在不另行通知用户的情况下直接采取一切必要的措施（包括但不限于删除图片、暂停或终止用户使用秀美图功能）以减轻用户不当行为造成的影响。<br>
                </p>
                <p>4、用户发表或上传的内容仅代表用户自己的立场和观点，与本公司和网站无关，由用户本人承担一切相关法律责任。</p>
                <p><strong>三、权利说明</strong></p>
                <p>1、本公司网站上展示的内容以及用户在使用本网站服务时所获取的信息，包括不限于标识、版面设计、排版方式、文本、图片、图形等，均由本公司或授权本公司使用此类资料的第三方版权所有或以其他方式保护和所有。除非另行明确指出，未经本公司的书面明示同意，用户不得复制、下载、存储、转载、发布、修改或以其他方式使用上述内容</p>
                <p class="">2、用户承诺对其发表或上传于秀美图平台的所有内容，包括但不限于文字、图片、链接等，均享有完全的知识产权或者已经取得合法的授权（包括不限于：发表或上传的授权、将有关著作权转让的授权等）。如有第三方认为用户发表或上传的内容侵犯其权利，并向本公司发送权利主张和/或赔偿要求时，本公司有权要求该第三方和/或相关用户提供有效的权属证明，并享有独自决定采取措施（如：不另行通知即删除相关内容）的权利。因此给本公司造成损失的，由用户或该等第三方承担全部赔偿责任，包括不限于赔偿费、律师费、诉讼费及其它相关费用。</p>
                <p>3、用户同意将其发表或上传内容除署名权之外的所有著作权利，包括但不限于：:复制权、发行权、出租权、展览权、表演权、放映权、广播权、信息网络传播权、摄制权、改编权、翻译权、汇编权及应由著作权人享有的其他可转让权利，无偿独家转让给皇家加勒比所有。</p>
                <p>4、用户进一步同意，本使用规则已经构成《著作权法》第二十五条所规定的书面协议，其效力及于用户在本网站上已经或即将发表或上传的所有内容。用户同意并理解上述条款，不得将发表或上传于本网站的任何信息，以任何形式发布或授权、转让其他第三方使用。</p>
                <p>5、用户发表或上传的内容，未经本公司和发布用户的书面同意，禁止转载、复制或以其他方式使用。</p>
                <p>6、本网站及其内容均受著作权法等相关法律法规的保护，严厉禁止任何机器人、网络爬虫、其他技术手段等监测、复制、窃取、扰乱、破坏或以其他方式影响本网站的管理和运营，一经发现，皇家加勒比将依法追究其法律责任。</p>
            </div>
            <div class="close" @click="hide"><img src="../../assets/closed.png" class=""></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'Protocol',
        props: {
            isShow: {
                type: Boolean,
                default: false
            }
        },
        methods: {
            hide () {
                this.$emit('on-close')
            }
        }
    }
</script>

<style lang="less">
    .uploadPicture-protocol {
        position: fixed;
        z-index: 2222;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0,0,0,.6);
        .uploadPicture-protocolCon {
            margin:88px 12px 0 12px;
            background-color:#fff;
            border-radius:4px;
            position:relative;
            padding:15px;
            .article{
                max-height:380px;
                overflow-y:auto;
                overflow-x:hidden;
                h1{
                    font-size:13px;
                    font-weight:bold;
                    color:#666;
                }
                p{
                    width:100%;
                    font-size:12px;
                    color:#666;
                    margin-top:4px;
                    margin-bottom:4px;
                    word-break:break-all;
                }
            }
            .close {
                position:absolute;
                right:5px;
                top:5px;
                width:23px;
                height:23px;
                img{
                    width:100%;
                }
            }
        }
    }
</style>
